import { Cart } from '../models/cart.model';
import {
  Department,
  DepartmentWithResidents,
} from '../models/department.model';

export function departmentTotals(
  carts: Cart[],
  departments: Department[] = []
): Record<number, number> {
  const totals: Record<number, number> = {};
  departments.forEach(department => {
    const cart = carts.find(c => c.departmentId === department.departmentId);
    totals[department.departmentId] = cart?.total || 0;
  });
  return totals;
}

export function residentTotals(
  carts: Cart[],
  department: DepartmentWithResidents | null
): Record<number, number> {
  const totals: Record<number, number> = {};
  const cart = carts.find(c => c.departmentId === department?.departmentId);
  department?.people?.forEach(resident => {
    totals[resident.id] = cart?.getResidentCart(resident.id)?.total || 0;
  });
  return totals;
}
